import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { NgModel } from '@angular/forms';
import { UtilsService } from 'src/app/shared/services';
declare var $: any;

@Component({
    selector: 'app-shared-confirm-modal',
    templateUrl: './confirm-modal.component.html',
    styleUrl: './confirm-modal.component.scss',
    standalone: false
})
export class ConfirmModalComponent {
  @ViewChild('remarkModel') remarkModel!: NgModel; // Access the ngModel instance
  @Input() payload: any = '';
  @Input() showRemark: boolean = true; // used to show remark boxor not for user comments
  @Input() reverseButton: boolean= false;
  @Output() buttonSubmit = new EventEmitter();
  @Output() onModalClose = new EventEmitter();
    
  @HostListener('document:keydown', ['$event'])
    handleKeyboardEvent(event: KeyboardEvent): void {
    if (event.key === 'Enter') {
      this.fnCloseModal();
    }
  }

  public remark: any = '';
  public invalidRemark: boolean = false;
  isFormSubmitted: boolean = false;
  public remarkFieldTouched: boolean = false;
  isActionButtonDisabled: boolean = false;
  constructor(public utilsService: UtilsService) {}
  
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.payload?.currentValue) {
      this.payload.header = changes.payload.currentValue.header;
      this.payload.body = changes.payload.currentValue.body;
      this.payload.componentName = changes.payload.currentValue.componentName;
      this.payload.extras = changes.payload.currentValue.extras;
      this.payload.buttonText1 = changes.payload.currentValue.buttonText1;
      this.payload.buttonText2 = changes.payload.currentValue.buttonText2;
      this.payload.invalidMessage = changes.payload.currentValue.invalidMessage;
      this.payload.isInvalidMessage =
        changes.payload.currentValue.isInvalidMessage;
    }
  }

  ngOnInit(): void {}

  fnOpenModal() {
    this.invalidRemark = false;
    this.remark = '';
    if (this.showRemark) {
      this.remarkModel.reset('');
    }

    $('#sharedConfirmModal').modal('show');
  }

  fnCloseModal() {
    this.isFormSubmitted = false;
    $('#sharedConfirmModal').modal('hide');
    this.onModalClose.emit();
  }

  fnSubmit() {
    this.isFormSubmitted = true;
    let payload = {
      componentName: this.payload.componentName,
      extras: this.payload.extras,
      id: this.payload.id,
      remark: this.remark,
    };
    if (this.isFormSubmitted && this.showRemark && this.remark === '') {
      return;
    }
    this.buttonSubmit.emit(payload);
  }

  changeRemarkStatus() {
    if (this.remark === '') {
      this.invalidRemark = true;
    } else {
      this.invalidRemark = false;
    }
  }

  markAsTouched() {
    this.remarkFieldTouched = true;
  }
}
